document.getElementById('cupom-imagem').addEventListener('click', () => {
  const popup = document.getElementById('promo-popup');
  const overlay = document.getElementById('popup-overlay');
  const closeButton = document.querySelector('.close-icon');
 
      // Exibe o popup e o overlay
  
      popup.classList.add('active');
      overlay.classList.add('active');

      // Transições de animação
      setTimeout(() => {
        popup.classList.add('content-visible');
      }, 150);

      setTimeout(() => {
        popup.classList.add('content-slide');
      }, 750);

      setTimeout(() => {
        popup.classList.add('image-slide');
      }, 650);

  // Lógica para fechar o popup ao clicar no overlay
  overlay.addEventListener('click', () => {
    popup.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
    popup.style.opacity = '0';
    overlay.style.transition = 'opacity 0.8s ease-out';
    overlay.style.opacity = '0';

    setTimeout(() => {
      popup.classList.remove('active', 'content-visible', 'content-slide', 'image-slide' );
      overlay.classList.remove('active');
      popup.style.opacity = '';
      overlay.style.opacity = '';
    }, 400); // Tempo para permitir que a animação finalize
  });
    closeButton.addEventListener('click', () => {
    popup.style.transition = 'opacity 0.8s ease-out, transform 0.8s ease-out';
    popup.style.opacity = '0';
    overlay.style.transition = 'opacity 0.8s ease-out';
    overlay.style.opacity = '0';

    setTimeout(() => {
      popup.classList.remove('active', 'content-visible', 'content-slide', 'image-slide' );
      overlay.classList.remove('active');
      popup.style.opacity = '';
      overlay.style.opacity = '';
    }, 400); // Tempo para permitir que a animação finalize
  });
});


  document.getElementById('phone').addEventListener('input', function (e) {
    let value = e.target.value.replace(/\D/g, ''); // Remove tudo que não for número
    value = value.replace(/^(\d{2})(\d)/, '($1) $2'); // Adiciona parênteses ao DDD
    value = value.replace(/(\d{5})(\d)/, '$1-$2'); // Adiciona o traço ao número
    e.target.value = value;
  });

  document.getElementById('phone').addEventListener('keydown', function (e) {
    if (e.key !== 'Backspace' && /\D/.test(e.key)) {
      e.preventDefault(); // Bloqueia qualquer tecla que não seja número
    }
  });


 document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('contact_forms');
  const messages = document.getElementById('form-messages');


  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault(); // Impede o redirecionamento da página

      const formData = new FormData(form);
      const action = form.action || window.location.href;

      fetch(action, {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
        },
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok.');
        })
        .then(data => {
          messages.innerHTML = '<h2>Thank you for signing up!</h2>';
          form.reset(); // Reseta o formulário após o envio bem-sucedido
        })
        .catch(error => {
          messages.innerHTML = '<h2>There was an error. Please try again.</h2>';
          console.error('Error:', error);
        });
    });
  } else {
    console.error('Form not found. Check the ID.');
  }
});


